export default "__VITE_ASSET__2323d86e__"